import {KTIcon} from '../../../../_metronic/helpers'
import {ReceiverType, Student} from '../types'

type RecipientsProps = {
  recieverType: ReceiverType
  standard: {
    class_Name: string | null
    divisionName: string | null
  }
  students: Student[] | null
}

const AllStudentsView = () => (
  <div className="fs-2 text-gray-700 mb-4 lead">Every student in the school</div>
)

const StandardView = ({standard}: {standard: RecipientsProps['standard']}) => (
  <div className="fs-4 text-gray-600">
    All Student studying in
    <div>
      Class: {standard?.class_Name}, Division: {standard?.divisionName}
    </div>
  </div>
)

const SpecificStudentsView = ({students}: {students: Student[]}) => (
  <div className="d-flex flex-column gap-5">
    {students?.map((student) => (
      <div key={student.student_id} className="border border-secondary small rounded-1">
        <div className="d-flex justify-content-between px-3 py-2">
          <span>{student.student_name}</span>
          <span className="text-gray-600 fw-medium">Reg-ID: {student.student_id}</span>
        </div>
        <div className="d-flex justify-content-between px-3 py-2 border-top border-secondary text-gray-600 fw-medium">
          <span>Class: {student.class}</span>
          <span>Division: {student.division}</span>
        </div>
      </div>
    ))}
  </div>
)

function Recipients({recieverType, standard, students}: RecipientsProps) {
  const recieverTypeView = () => {
    switch (recieverType) {
      case 'all':
        return <AllStudentsView />
      case 'standard':
        return <StandardView standard={standard} />
      case 'specific':
        return <SpecificStudentsView students={students!} />
      default:
        return null
    }
  }
  return (
    <div className="mt-5">
      <div className="fs-5 text-gray-600 mb-2 d-flex align-items-center">
        Broadcasted to
        <KTIcon iconName="satellite" className="fs-1 mb-2 ms-1 text-dark" />
      </div>
      {recieverTypeView()}
    </div>
  )
}

export default Recipients
